import { FilterStringComponent, SearchQueryByFilter, SearchTemplate } from '../../../../../../generic-search-common/src'
import { useEffect, useState } from 'react'
import { PillSelected } from '../pill-selected'
import { flattenFiltersToSelected } from '../../../../../../generic-search-common/src'
import { SkeletonPill } from '@msaf/core-react'

export interface CollapsedFiltersProps {
  modifyValues: () => void
  query: SearchQueryByFilter
  searchTemplate: SearchTemplate
  lookupResolver?: (value: string, optionsKey?: string, searchTypeKey?: string) => Promise<string>
}

export function CollapsedFilters({ modifyValues, query, searchTemplate, lookupResolver }: CollapsedFiltersProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [displaySegments, setDisplaySegments] = useState<{
    [filter: string]: FilterStringComponent[][]
  }>({})

  useEffect(() => {
    async function getDisplaySegments() {
      setIsLoading(true)
      try {
        const segments = await flattenFiltersToSelected(query, searchTemplate, { lookupResolver })
        setDisplaySegments(segments)
      } catch {
        // TODO: Error handling
        setDisplaySegments({})
      }
      setIsLoading(false)
    }
    getDisplaySegments()
  }, [query, lookupResolver, searchTemplate])

  if (isLoading) {
    return <SkeletonPill />
  }

  const pills = searchTemplate.filters.flatMap((f) => {
    if (!(f.filterKey in displaySegments)) {
      return []
    }

    return displaySegments[f.filterKey].map((segments, i) => (
      // Unlikely to re-render these, so index is fine as a key component
      <PillSelected
        key={`${f.filterKey}-${i}`}
        isEnabled
        label={f.label}
        modifyValues={modifyValues}
        displaySegments={segments}
      />
    ))
  })

  // Need to return a single element for render purposes
  return <>{pills}</>
}
